/* Lucky Number 24 — mobile helpers: hero swipe dots, 4-card cap that Load More lifts, "see all numbers" button */
(function(){
  if(!window.matchMedia('(max-width:749px)').matches) return;
  function dots(){
    var row=document.getElementById('ln24h-row'); if(!row||row.dataset.m) return;
    var cards=row.querySelectorAll(':scope>a'); if(cards.length<2) return;
    row.dataset.m=1;
    var d=document.createElement('div'); d.className='ln24m-dots';
    for(var i=0;i<cards.length;i++) d.appendChild(document.createElement('i'));
    d.firstChild.className='on';
    row.parentNode.insertBefore(d,row.nextSibling);
    row.addEventListener('scroll',function(){
      var w=cards[0].offsetWidth+10, k=Math.round(row.scrollLeft/w);
      [].forEach.call(d.children,function(el,j){el.className=j===k?'on':'';});
    },{passive:true});
  }
  function seeAll(){
    var g=document.getElementById('ln24a-grid'); if(!g||document.querySelector('.ln24m-all')) return;
    var b=document.querySelector('#ln24h .ln24h-btn-secondary');
    var a=document.createElement('a'); a.className='ln24m-all';
    a.href=b?b.getAttribute('href'):'/pages/browse-numbers';
    var lang=(document.documentElement.lang||'en').slice(0,2);
    a.textContent=lang==='th'?'ดูเบอร์ทั้งหมด →':lang==='zh'?'查看全部号码 →':'See all numbers →';
    var lw=document.querySelector('.ln24a-loadwrap');
    (lw||g).parentNode.insertBefore(a,(lw||g).nextSibling);
  }
  function cap(){
    var g=document.getElementById('ln24a-grid'); if(!g||g.dataset.cap) return;
    g.dataset.cap=1; g.classList.add('ln24m-capped');
    var b=document.getElementById('ln24a-loadmore');
    if(b) b.addEventListener('click',function(){g.classList.remove('ln24m-capped');},true);
  }
  function run(){dots();cap();seeAll();}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run); else run();
  setTimeout(run,1500); setTimeout(run,4000);
})();